import { CONFIGURED_SERVICE_EVENT_TYPE, PRICED_SERVICE_TYPE } from 'settings/constants/service'

export interface OneOffStopFields {
  readonly configuredServiceEventType?: string | null
  readonly pricedServiceType?: string | null
}

const normalize = (raw: unknown): string =>
  typeof raw === 'string'
    ? raw
        .trim()
        .toLowerCase()
        .replace(/[\s-]+/g, ' ')
    : ''

/**
 * Identifies the manually-added extra stop dispatchers mistake for a duplicate:
 * a one-off event on any service that isn't On Request (a missing
 * `pricedServiceType` still counts). Excluding On Request is load-bearing — the BE
 * stamps `event_type = 'One Off'` on every event of one, so it would match too.
 */
export const isOneOffStop = (stop?: OneOffStopFields | null): boolean => {
  if (!stop) return false
  if (normalize(stop.pricedServiceType) === normalize(PRICED_SERVICE_TYPE.ON_REQUEST)) return false
  return normalize(stop.configuredServiceEventType) === CONFIGURED_SERVICE_EVENT_TYPE.ONE_OFF
}
